// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__77lcz","content":"styles_content__3I_8s","tableWrap":"styles_tableWrap__1pREE"};